import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import HttpService from '../../services/httpService'
import { makeStyles, withStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import {Paper, Button, Table, TableHead, TextField, Checkbox, TableBody, TableCell, TableContainer, TableRow, Box} from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 600,
  },
  updateButton: { backgroundColor: '#0b8072', color: 'white', padding: '1', marginRight: '0.5em', marginLeft: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#075E54", color: 'white' } },
  editButton: { backgroundColor: 'white', color: '#3d444f', padding: '1', marginRight: '0.5em', borderRadius: '20px', "&:hover": { backgroundColor: "#3d444f", color: 'white' } },
});

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#ccc",
    color: theme.palette.common.black,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const   WhatsApp_Stages_Operations = (props) => {
  const classes = useStyles();
  const [customerActiveStage, setCustomerActiveStages] = useState([]);
  const [whatsAppNotificationTemplates, setWhatsAppNotificationTemplates] = useState([]);
  const [openEditWhatsAppNotificationTemplateDialog, setOpenEditWhatsAppNotificationTemplateDialog] = useState(false);
  const [whatsAppNotificationTemplateDataForSelectedStage, setWhatsAppNotificationTemplateDataForSelectedStage] = useState({});
  
  const [operationsStages, setOperationsStages] = useState([]);
  const [whatsAppNotificationStage, setWhatsAppNotificationStage] = useState([]);


  const getDepartmentStagesList = async () => {
    props.setLoading(true);
    try {
      const result = await HttpService.departmentStages('Operations');
      setOperationsStages(result.data[0].stages)
      setWhatsAppNotificationStage(result.data[0].whatsAppNotificationStages);
    }
    catch (err) {
      console.error(err);
    }
    props.setLoading(false);
  }

  const getWhatsAppNotificationTemplates = async () => {
    props.setLoading(true);
    try {
      const response = await HttpService.getWhatsAppNotificationTemplates();
      setWhatsAppNotificationTemplates(response.data);
    }
    catch (err) {
      console.error(err);
    }
    props.setLoading(false);
  }

  const handleWhatsAppCheckboxChange = (stage) => {
    let tempArr = [...whatsAppNotificationStage]
    if(tempArr.indexOf(stage) < 0) {
      tempArr.push(stage)
    } else {
     tempArr = tempArr.filter(el => el !== stage)
    }
    setWhatsAppNotificationStage(tempArr)
  };

  const handleWhatsAppNotificationStages = async () => {
    props.setLoading(true);
    try {
      const obj = {
        whatsAppNotificationStagsArray: whatsAppNotificationStage,
        departmentName : 'Operations'
      };
      const response = await HttpService.updateWhatsAppNotificationStages(obj);
      if (response.status === 200) {
        props.setSnackInfo(response.data, "success");
      }
    } catch (err) {
      console.log("Something went wrong", err);
    }
    props.setLoading(false);
  };

  const handleWhatsAppTemplateEdit = async (stage) => {
    props.setLoading(true);
    try {
      const desiredTemplate = whatsAppNotificationTemplates.filter(template => template.stage_name == stage)
      if(desiredTemplate.length) {
        setWhatsAppNotificationTemplateDataForSelectedStage(desiredTemplate[0])
      } else {
        setWhatsAppNotificationTemplateDataForSelectedStage({stage_name: stage})
      }
      setOpenEditWhatsAppNotificationTemplateDialog(true)
    } catch (err) {
      console.log("Something went wrong", err);
    }
    props.setLoading(false);
  };

  const handle_whatsApp_template_details_change = (e) => {
    setWhatsAppNotificationTemplateDataForSelectedStage({...whatsAppNotificationTemplateDataForSelectedStage, [e.target.name]: e.target.value})
  }

  const handle_close_edit_whatsApp_notification_template_dialog = () => {
    setOpenEditWhatsAppNotificationTemplateDialog(false)
    setWhatsAppNotificationTemplateDataForSelectedStage({})
  }

  const handle_update_whatsApp_notification_template = async () => {
    props.setLoading(true)
    try {
      const response = await HttpService.updateWhatsAppNotificationTemplate(whatsAppNotificationTemplateDataForSelectedStage)
      if (response.status === 200) {
        props.setSnackInfo(response.data, "success");
      } else {
        props.setSnackInfo(response.data, "error");
      }
    } catch(error) {
      props.setSnackInfo(error.response.data, "error");
      console.log('error', error.message)
      console.error(error)
    }
    setOpenEditWhatsAppNotificationTemplateDialog(false)
    setWhatsAppNotificationTemplateDataForSelectedStage({})
    getWhatsAppNotificationTemplates()
    props.setLoading(false)
  }

  const MessageComponent = ({ name, message }) => {
    const formattedMessage = message.replace('{{name}}', `<strong>${name}</strong>`);

    const bubbleStyle = {
      backgroundColor: '#dcf8c6',
      padding: '10px 15px',
      borderRadius: '15px',
      marginBottom: '10px',
      maxWidth: '300px',
      position: 'relative',
      fontFamily: 'Arial, sans-serif',
      fontSize: '14px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      margin: '20px auto',
    };
  
    const tailStyle = {
      position: 'absolute',
      bottom: '0',
      left: '-10px',
      width: '0',
      height: '0',
      borderTop: '10px solid transparent',
      borderBottom: '10px solid transparent',
      borderRight: '10px solid #dcf8c6',
    };
  
    return (
      <div style={{ position: 'relative', display: 'inline-block' }}>
        <div style={bubbleStyle}>
          {formattedMessage.split('\n').map((line, index) => (
          <p key={index} dangerouslySetInnerHTML={{ __html: line.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>') }}></p>
        ))}
          <div style={tailStyle}></div>
        </div>
      </div>
    );
  };

  useEffect(() => {
    getDepartmentStagesList();
    getWhatsAppNotificationTemplates()
  }, [])

  

  return (
    <div>
      <TableContainer component={Paper}>
        <Table
          className={classes.table}
          size="small"
          aria-label="customized table"
        >
          <TableHead>
            <TableRow>
              <StyledTableCell style={{ textAlign: "center" }}> Sl No. </StyledTableCell>
              <StyledTableCell style={{ textAlign: "center" }}>Stage Name </StyledTableCell>
              <StyledTableCell style={{ textAlign: "center" }}>
                Enable WhatsApp Notification
                <Button
                  variant="contained"
                  color="primary"
                  className={classes.updateButton}
                  onClick={() => handleWhatsAppNotificationStages()}
                >
                  Update
                </Button>
              </StyledTableCell>
              <StyledTableCell style={{ textAlign: "center" }}>Message Template</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {operationsStages.map((stage, index) => (
              <StyledTableRow key={index}>
                <StyledTableCell style={{ textAlign: "center" }}>{index + 1}</StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}>{stage}</StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}> <Checkbox checked={whatsAppNotificationStage?.includes(stage)} onChange={() => handleWhatsAppCheckboxChange(stage, index)} /> </StyledTableCell>
                <StyledTableCell style={{ textAlign: "center" }}> <Button disabled={false} className={classes.editButton} variant="contained" onClick={() => handleWhatsAppTemplateEdit(stage, index)}><EditIcon /></Button> </StyledTableCell>
              </StyledTableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Dialog open={openEditWhatsAppNotificationTemplateDialog} onClose={() => handle_close_edit_whatsApp_notification_template_dialog()}>
          <DialogTitle>Template Details</DialogTitle>
            <DialogContent>
                <Box sx={{ minWidth: 450 }}>
                    <FormControl fullWidth variant="outlined" size="small">
                        <TextField disabled={true} label="Stage Name" size="small" value={whatsAppNotificationTemplateDataForSelectedStage.stage_name} style={{ marginBottom: 20 }} name="stage_name" onChange={e => handle_whatsApp_template_details_change(e)} variant="outlined" />
                        <TextField label="Template Name" size="small" value={whatsAppNotificationTemplateDataForSelectedStage.template_name} style={{ marginBottom: 20 }} name="template_name" onChange={e => handle_whatsApp_template_details_change(e)} variant="outlined" />
                        <TextField label="Gupshup Template ID" size="small" value={whatsAppNotificationTemplateDataForSelectedStage.gupshup_template_id} style={{ marginBottom: 20 }} name="gupshup_template_id" onChange={e => handle_whatsApp_template_details_change(e)} variant="outlined" />
                        <TextField label="Facebook Template ID" size="small" value={whatsAppNotificationTemplateDataForSelectedStage.facebook_template_id} style={{ marginBottom: 20 }} name="facebook_template_id" onChange={e => handle_whatsApp_template_details_change(e)} variant="outlined" />
                        <TextField label="Message Partner" size="small" value={whatsAppNotificationTemplateDataForSelectedStage.message_partner} style={{ marginBottom: 20 }} name="message_partner" onChange={e => handle_whatsApp_template_details_change(e)} variant="outlined" />
                        {openEditWhatsAppNotificationTemplateDialog && <MessageComponent name="Customer" message={whatsAppNotificationTemplateDataForSelectedStage.template_content} />}
                    </FormControl>
                </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={() => handle_close_edit_whatsApp_notification_template_dialog()} variant="outlined" color="primary">Cancel</Button>
              <Button variant="contained" color="primary" size="small" onClick={() => handle_update_whatsApp_notification_template()}>Update</Button>
          </DialogActions>
        </Dialog>
    </div>
  );
};

export default connect(null, { setLoading, setSnackInfo })(WhatsApp_Stages_Operations);